module.exports = __webpack_public_path__ + "static/media/udemy-react.63f968e4.jpg";